





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// MARKNOTIFICATIONASREADFORCUSTOMER
// MARKNOTIFICATIONASREADFORCUSTOMER


const MARKNOTIFICATIONASREADFORCUSTOMER= createAsyncThunk(
  "markNotificationAsReadForCustomer/markNotificationAsReadForCustomer",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const markNotificationAsReadForCustomerSlice = createSlice({
  name: "markNotificationAsReadForCustomerSlice",
  initialState: {
    markNotificationAsReadForCustomer: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfmarkNotificationAsReadForCustomer: (state) => {
        state.markNotificationAsReadForCustomer.loading = false
        state.markNotificationAsReadForCustomer.error = false
        state.markNotificationAsReadForCustomer.data = []
        state.markNotificationAsReadForCustomer.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MARKNOTIFICATIONASREADFORCUSTOMER.fulfilled, (state, action) => {
      state.markNotificationAsReadForCustomer = {
        ...state.markNotificationAsReadForCustomer,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MARKNOTIFICATIONASREADFORCUSTOMER.pending, (state, action) => {
      state.markNotificationAsReadForCustomer = {
        ...state.markNotificationAsReadForCustomer,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MARKNOTIFICATIONASREADFORCUSTOMER.rejected, (state, action) => {
      state.markNotificationAsReadForCustomer = {
        ...state.markNotificationAsReadForCustomer,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const markNotificationAsReadForCustomerAction = {
    MARKNOTIFICATIONASREADFORCUSTOMER,
};

export { markNotificationAsReadForCustomerAction };
export default markNotificationAsReadForCustomerSlice.reducer;
export const {setInitialStateOfmarkNotificationAsReadForCustomer} = markNotificationAsReadForCustomerSlice.actions
